'use strict';

var _classCallCheck = require("/Users/klaushottvidal/DAPPS/remix-plugin-prettier/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/klaushottvidal/DAPPS/remix-plugin-prettier/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/klaushottvidal/DAPPS/remix-plugin-prettier/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/klaushottvidal/DAPPS/remix-plugin-prettier/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var utils = require('./utils');

var LineComment = require('./line');
/**
 * Create a new BlockComment
 *
 * @param {String} `str` string of JavaScript
 * @param {Object} `token` Parsed AST token
 */


var BlockComment =
/*#__PURE__*/
function (_LineComment) {
  _inherits(BlockComment, _LineComment);

  function BlockComment(str, token) {
    var _this;

    _classCallCheck(this, BlockComment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BlockComment).call(this, str, token));
    _this.value = utils.stripStars(_this.raw);
    return _this;
  }

  return BlockComment;
}(LineComment);
/**
 * expose `BlockComment`
 */


module.exports = BlockComment;